import { render } from "./ProjectModal.vue?vue&type=template&id=5c5bd717"
import script from "./ProjectModal.vue?vue&type=script&lang=js"
export * from "./ProjectModal.vue?vue&type=script&lang=js"

import "./ProjectModal.vue?vue&type=style&index=0&id=5c5bd717&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__